import ExceptionService from '../ExceptionService.js'

export default class StorageService {

  static get KEYS() {
    return {
      PROFILES: 'eko-user-profiles',
      ACTIVE_PROFILE: 'eko-active-profile'
    }
  }

  constructor() {
    this.logging = new ExceptionService()
  }

  set = (key, json) => {
    try {
      localStorage.setItem(key, JSON.stringify(json))
      return true
    } catch (e) {
      window.showAlert(
        translateText(this._translations(), 'set_title'),
        translateText(this._translations(), 'set_text'),
        'error'
      )
      const error = {message: `Error storing item ${key} in localStorage:`, stack: e.stack}
      this.logging.log(error)
      return false
    }
  }

  get = (key, def = null) => {
    try {
      const data = localStorage.getItem(key)
      return data ? JSON.parse(data) : def
    } catch (e) {
      window.showAlert(
        translateText(this._translations(), 'get_title'),
        translateText(this._translations(), 'get_text'),
        'error'
      )
      const error = {message: `Error retrieving item ${key} from localStorage`, stack: e.stack}
      this.logging.log(error)
      return def
    }
  }

  _translations() {
    return {
      de: {
        set_title: 'Beim speichern ist ein Fehler aufgetreten.',
        set_text: 'Die Änderungen konnten nicht gespeichert werden.',
        get_title: 'Beim lesen ist ein Fehler aufgetreten.',
        get_text: 'Die gespeicherten Daten konnten nicht gelesen werden.'
      }
    }
  }
}
